import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyles from 'assets/styles/default.scss';

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        borderLeftStyle: 'solid',
        borderLeftWidth: 3,
        borderLeftColor: sicrediStyles.primarySicredi,
        padding: 0,
        position: 'relative',
      },
      clickArea: {
        padding: theme.spacing(3, 6, 3, 3),
      },
      iconChevron: {
        transform: 'rotate(90deg)',
        color: sicrediStyles.primarySicredi,
        position: 'absolute',
        top: 24,
        right: 16,
        width: 24,
        height: 24,
      },
      titleGroup: {
        minHeight: 104,
        marginBottom: theme.spacing(1.5),
      },
      tipo: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 16,
        fontWeight: 700,
        lineHeight: '24px',
        color: sicrediStyles.primarySicredi,
        marginBottom: theme.spacing(1),
      },
      nome: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '24px',
        color: sicrediStyles.primarySicredi,
      },
      dataContainer: {
        display: 'flex',
        flexDirection: 'column',
      },
      titleData: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
      },
      currentData: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '24px',
        marginBottom: theme.spacing(2),
      },
      chipCoop: {
        backgroundColor: sicrediStyles.primarySicrediLight,
        '& svg': {
          width: 16,
          height: 16,
          color: sicrediStyles.primarySicredi,
        },
      },
      iconAgencia: {
        color: sicrediStyles.primarySicredi,
        height: 20,
        width: 20,
      },
    }),
  {
    name: 'CartaoEvento',
  }
);
